import styled from "styled-components";

export const StyledText = styled.div`
  margin-top: 100px;
`;

export const Item = styled.div`
  margin-top: 25px;
`;
